export default __webpack_public_path__ + "static/media/linkedin.51231ff3.svg";